import { useMutation } from "urql";
import {
  UpsertSongbookMutationMutation,
  UpsertSongbookMutationMutationVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useUpsertSongbookMutation() {
  return useMutation(upsertSongbookMutation);
}

export const upsertSongbookMutation: TypedDocumentNode<
  UpsertSongbookMutationMutation,
  UpsertSongbookMutationMutationVariables
> = graphql(`
  mutation upsertSongbookMutation(
    $id: ID!
    $name: String!
    $mnemonic: String!
    $bucket: String!
  ) {
    upsertSongbook(id: $id, name: $name, mnemonic: $mnemonic, bucket: $bucket) {
      id
      bucket
      mnemonic
      name
    }
  }
`);
